import { v4 as uuid } from 'uuid';

export function createUniqueId(): string {
  return uuid();
}

export const createGuid = (): string => {
  return createUniqueId();
};
